// (function () {
//     'use strict';

//     angular.module("imApp").factory("orderHeadChoicesService", [function () {
//         let service = {};

//         return service;
//     }]);
// })();
